import { AbstractControl, ValidatorFn } from '@angular/forms';

export function luhnValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    const lastCharacter = control.value?.substring(control.value?.length - 1);
    let value = control.value;
    if (lastCharacter === 'F') {
      value = value.substring(0, value.length - 1);
    }

    var isValid = (function (a) {
      return function (c) {
        for (var l = c?.length, b = 1, s = 0, v; l; )
          (v = parseInt(c.charAt(--l), 10)), (s += (b ^= 1) ? a[v] : v);
        return s && 0 === s % 10;
      };
    })([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]);

    return isValid(value) ? null : { luhnCheck: true };
  };
}
